import { useMemo } from 'react'

import { useUser } from 'modules/AccessManage/hooks/useUser'

import ModalWindowLayout from 'shared/ui/ModalWindowLayout'

interface Props {
  value: boolean
  userId?: string
}
const ChangeIsBlockedUser = ({ value, userId }: Props) => {
  const { handleChangeIsBlockedUser, user, isUpdateUserLoading } = useUser({
    userId,
  })

  const title = useMemo(
    () =>
      `Вы действительно хотите ${value ? 'заблокировать' : 'разблокировать'} пользователя ${user?.full_name}?`,
    [value, user?.full_name],
  )

  const handleBlockUser = async () => {
    await handleChangeIsBlockedUser(value)
  }

  return (
    <ModalWindowLayout
      title={title}
      titleContentGap={24}
      submitClassname="w-[134px] !bg-red_2"
      onSubmit={handleBlockUser}
      isLoading={isUpdateUserLoading}
    >
      {value && (
        <span className="text-[15px] leading-[22px] text-dark">
          Данный пользователь потеряет все доступы к системе ЛОГО. Вы сможете
          разблокировать пользателя позже.
        </span>
      )}
    </ModalWindowLayout>
  )
}

export default ChangeIsBlockedUser
